/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Cancel_ConfirmInputs */

const en_us2_workout_after_cancel_confirm = /** @type {(inputs: Workout_After_Cancel_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel workout`)
};

const pt_br2_workout_after_cancel_confirm = /** @type {(inputs: Workout_After_Cancel_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar treino`)
};

const es_419_workout_after_cancel_confirm = /** @type {(inputs: Workout_After_Cancel_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar entrenamiento`)
};

const pt_pt2_workout_after_cancel_confirm = /** @type {(inputs: Workout_After_Cancel_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar treino`)
};

const fr_fr2_workout_after_cancel_confirm = /** @type {(inputs: Workout_After_Cancel_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler la séance`)
};

const de_de2_workout_after_cancel_confirm = /** @type {(inputs: Workout_After_Cancel_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training abbrechen`)
};

const it_it2_workout_after_cancel_confirm = /** @type {(inputs: Workout_After_Cancel_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla allenamento`)
};

/**
* | output |
* | --- |
* | "Cancel workout" |
*
* @param {Workout_After_Cancel_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_cancel_confirm = /** @type {((inputs?: Workout_After_Cancel_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Cancel_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_cancel_confirm(inputs)
	if (locale === "es-419") return es_419_workout_after_cancel_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_cancel_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_cancel_confirm(inputs)
	if (locale === "de-DE") return de_de2_workout_after_cancel_confirm(inputs)
	if (locale === "it-IT") return it_it2_workout_after_cancel_confirm(inputs)
	return en_us2_workout_after_cancel_confirm(inputs)
});
export { workout_after_cancel_confirm as "workout-after.cancel_confirm" }